export default "__VITE_ASSET__B5hQwCF2__"